import { useEffect } from 'react';

const ExtensionRedirect = () => {
  useEffect(() => {
    // Redirect to Chrome Web Store
    window.location.href = 'https://chromewebstore.google.com/detail/stride-sales-coach/mnhnmmkhlbdamppclfeekbklfbphbboc';
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <p>Redirecting to Chrome Web Store...</p>
    </div>
  );
};

export default ExtensionRedirect;
